import * as React from 'react';
import './index.scss';
import { Avatar, Button, Card, Space } from 'antd';

interface TeamCardProps {
    name: string;
    members: string[];
}

const TeamCard: React.FC<TeamCardProps> = ({
    name,
    members,
}) => {
    const getInitals = (name: string) => {
        return name.split(' ').map(e => e[0]).join('');
    }

    return (
        <React.Fragment>
            <Card className='card_box'>
                <div className='justify_content'>
                    <div>{name}</div>
                    <Space direction='horizontal'>
                        <Avatar.Group>
                            {members.map(ele => <Avatar>{getInitals(ele)}</Avatar>)}
                        </Avatar.Group>
                    </Space>
                </div>
            </Card>
        </React.Fragment>
    );
};

export default TeamCard;
